/* eslint-disable jsx-a11y/alt-text */
import { Link } from "react-router-dom";

const Navbar = () => {
  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  return (
    <>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        <button
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
        >
          <i className="fa fa-bars"></i>
        </button>

        <ul className="navbar-nav ml-auto">
          <div className="topbar-divider d-none d-sm-block"></div>

          <li className="nav-item dropdown no-arrow">
            <Link
              className="nav-link dropdown-toggle"
              to={"#"}
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                {userInfo.nome}
              </span>
              <img
                className="img-profile rounded-circle"
                src="img/undraw_profile.svg"
              />
            </Link>

            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <Link className="dropdown-item" to={"/credencial"}>
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                Credencial
              </Link>

              <Link className="dropdown-item" to={"/credencial-dependentes"}>
                <i className="fas fa-users fa-sm fa-fw mr-2 text-gray-400"></i>
                Dependentes
              </Link>

              <div className="dropdown-divider"></div>

              <Link className="dropdown-item" to={"/choice-pass"}>
                <i className="fas fa-user-circle fa-sm fa-fw mr-2 text-gray-400"></i>
                Perfil
              </Link>

              <div className="dropdown-divider"></div>
              <Link
                className="dropdown-item"
                to={"#"}
                data-toggle="modal"
                data-target="#logoutModal"
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                Logout
              </Link>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
